// getDatoCmsToken.ts

export const getDatoCmsToken = (): string => {
  const hostname = window.location.hostname;
  
  // For development/testing, you can use a hardcoded token
  // If you have a DatoCMS API token, replace the empty string below
  const DEV_TOKEN = ""; // Replace with your development token if needed
  
  try {
    switch (hostname) {
      case 'ror.sumanthsamala.com':
      case 'sumanthsamala.com':
      case 'ror.localhost':
      case 'localhost':
        return process.env.REACT_APP_DATOCMS_ROR_TOKEN || DEV_TOKEN;

      case 'java.sumanthsamala.com':
      case 'java.localhost':
        return process.env.REACT_APP_DATOCMS_JAVA_TOKEN || DEV_TOKEN;

      case 'frontend.sumanthsamala.com':
      case 'frontend.localhost':
        return process.env.REACT_APP_DATOCMS_FRONTEND_TOKEN || DEV_TOKEN;

      case 'node.sumanthsamala.com':
      case 'node.localhost':
        return process.env.REACT_APP_DATOCMS_NODE_TOKEN || DEV_TOKEN;

      default:
        console.warn(`No specific DatoCMS token configured for hostname: ${hostname}, using default development token`);
        return DEV_TOKEN;
    }
  } catch (error) {
    console.warn("Error getting DatoCMS token, using empty token:", error);
    return DEV_TOKEN;
  }
};